import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PortfoliosService} from '../../../core/services/portfolios/portfolios.service';
import {catchError} from 'rxjs/operators';
import {of} from 'rxjs';
import {PortfolioByIsinDetail} from '../../../models/Portfolio/portfolio-by-isin-detail';

@Component({
  selector: 'app-show-portfolios-dialog',
  templateUrl: './show-portfolios-dialog.component.html',
  styleUrls: ['./show-portfolios-dialog.component.scss']
})
export class ShowPortfoliosDialogComponent implements OnInit {
  error = false;
  portfolios$ = this.portfoliosService
    .getPortfoliosByIsinDetails(this.data.isin, true)
    .pipe(
      catchError(() => {
        this.error = true;
        return of(null);
      })
    );

  constructor(
    private dialogRef: MatDialogRef<ShowPortfoliosDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {isin: string},
    private portfoliosService: PortfoliosService) { }

  ngOnInit(): void {
  }


  onSelectPortfolio(portfolio: PortfolioByIsinDetail) {
    this.dialogRef.close({id: portfolio.id, isin: this.data.isin, isinState: portfolio.isinState});
  }
}
